/* eslint-disable no-unused-vars */
import { AES as ABZ, enc as cne } from "crypto-js";
import { shouldUseEncryption } from "../services/HandlerService";
const abz = import.meta.env.VITE_CRYPT_KEY;
// to obfuscate
const private_key = 'private_key';

// Function to encrypt a text
export function encryptText(text, key = private_key) {
  const encryptedText = ABZ.encrypt((text), abz).toString();
  return encryptedText;
}

export function encryptJson(json, key = private_key) {
  const encryptedText = ABZ.encrypt(JSON.stringify(json), abz).toString();
  return encryptedText;
}

// Function to decrypt an encrypted text
export function decryptText(encryptedText, key = private_key) {
  const decryptedText = ABZ.decrypt(encryptedText, abz).toString(cne.Utf8);
  return decryptedText;
}

export function decryptJson(encryptedText, key = private_key) {
  if (shouldUseEncryption()) {
    const decryptedText = ABZ.decrypt(encryptedText, abz).toString(cne.Utf8);
    return JSON.parse(decryptedText);
  }
  return encryptedText;
}

// ghost function, to lost any reference to CryptoJS and methods encrypt and decrypt
export function ghostEncrypt(a) {
  return ABZ.encrypt(a, private_key).toString()
}

export function ghostDecrypt(a) {
  return ABZ.decrypt(a, private_key).toString(cne.Utf8)
}